// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getCustomer} from '../../../shared/repositories';

export const updateCustomerSummary = customerSummary => ({
    payload: customerSummary,
    property: 'customer',
    type: actions.READ_PRODUCT_DETAILS_CUSTOMER_SUCCESS
});

export const updateCustomer = (id, customerPrivate) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getCustomer(id, customerPrivate);

            dispatch({
                payload,
                property: 'customer',
                type: actions.READ_PRODUCT_DETAILS_CUSTOMER_SUCCESS
            });

        } catch (error) {

            dispatch({
                ckcCustomerFailed: true,
                type: actions.UPDATE_CKC_CUSTOMER_FAILURE
            });

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/customer.js